import React, { useMemo } from 'react';

import { useSettings } from '@atlas/core';
import { Icon, Label } from '@atlas/ui';

export const StatisticButton = ({ type, widgetData }) => {
  const { lang, theme } = useSettings();
  const { sportId, widgets } = widgetData;
  const statisticWidgetId = widgets?.find(widget => widget.type === 'STATISTIC')?.widgetId;

  const href = useMemo(() => {
    return `//stats.matchtracker.live/${lang.toLowerCase()}/${theme}/ro/${sportId}/${statisticWidgetId}`;
  }, [lang, theme, sportId, statisticWidgetId]);

  if (type === 'icon') {
    return (
      <a
        className="transparent-btn icon-box statistic-link-detailed"
        href={href}
        rel="noreferrer"
        target="_blank"
      >
        <Icon height={24} name="match-statistic" width={24} />
      </a>
    );
  }

  return (
    <div className="tab-list-item">
      <a className="statistic-link" href={href} rel="noreferrer" target="_blank">
        <Label message="Statistics" />
      </a>
    </div>
  );
};
